export default __webpack_public_path__ + "414d9ff46254c9dde2ba85e856c4dae7.png";